import { FC, useMemo } from 'react';
import { v4 } from 'uuid';
import { isArray, isNotEmpty } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { BrandSynergyItem, BrandSynergyModule, SmartDecisionValue } from './types';
import styles from './index.module.less';
import V2Table from '@/common/components/Data/V2Table';

interface BrandSynergyAnalysisProps {
  brandSynergyModule?: BrandSynergyModule;
  isPreset?: boolean;
}

type BrandSynergyRow = BrandSynergyItem & {
  id: string;
  isAverage?: boolean;
  source?: string;
  [p:string]: any;
};

/**
 * @description 品牌协同系数分析
 */
const BrandSynergyAnalysis: FC<BrandSynergyAnalysisProps> = ({ brandSynergyModule,
  isPreset,
}) => {
  const methods = useMethods({
    formatCoefficient(value: SmartDecisionValue) {
      if (!isNotEmpty(value)) return '-';
      // return beautifyThePrice(value || '', ',', 'auto');
      return isNotEmpty(value) ? value : '-';
    },
    getRows(): BrandSynergyRow[] {
      const rows = brandSynergyModule?.items && isArray(brandSynergyModule.items) ? brandSynergyModule.items : [];
      return [
        ...rows.map((item) => ({
          ...item,
          id: v4(),
        })),
        {
          id: v4(),
          isAverage: true,
          brandName: '综合加权（各协同源等权平均）',
          coefficient: brandSynergyModule?.weightedCoefficient,
        },
      ];
    },
    // renderSource(value: SmartDecisionValue) {
    //   console.log(value);
    //   return '';
    // },
    renderBrand(value: SmartDecisionValue) {
      return value || '-';
    },
    renderPosition(value: SmartDecisionValue, record: BrandSynergyRow) {
      // return record.isAverage ? '' : value || '-';
      if (record.isAverage) return '';
      const { floor, floorRelation } = record || {};
      let str = '';
      if (floor) {
        str = floor;
      }
      if (floorRelation) {
        str += `${floor ? '-' : ''} ${floorRelation}`;
      }
      return str || '-';
    },
    renderCoefficient(value: SmartDecisionValue, record: BrandSynergyRow) {
      // renderCoefficient
      if (record.isAverage) {
        return <>
          {`${isNotEmpty(value) ? `→ ${methods.formatCoefficient(value)}` : '-'}`}
          {
            isPreset && <span className='fs-12 c-999 pl-12'>未检索到协同品牌，系数按 1.0 计</span>
          }
        </>;
      }
      return `×${methods.formatCoefficient(value)}`;
      // return record.isAverage
      //   ? `${isNotEmpty(value) ? `→ ${methods.formatCoefficient(value)}` : '-'}`
      //   : `×${methods.formatCoefficient(value)}`;
    },
    getColumns() {
      return [
        // 没有协同来源
        // {
        //   key: 'source',
        //   title: '协同来源',
        //   render: methods.renderSource,
        // },
        {
          key: 'brandName',
          title: '代表品牌',
          render: methods.renderBrand,
        },
        {
          key: 'floor',
          title: '位置',
          render: methods.renderPosition,
        },
        {
          key: 'coefficient',
          title: '系数',
          render: methods.renderCoefficient,
        },
      ];
    },
    loadTable() {
      const dataSource = methods.getRows();
      return Promise.resolve({
        dataSource,
        count: dataSource.length,
      });
    },
    getRowClassName(record: BrandSynergyRow) {
      return record.isAverage ? styles.averageRow : '';
    },
  });

  const tableFilters = useMemo(() => ({ brandSynergyModule }), [brandSynergyModule]);

  return (
    <div className={styles.detailCard}>
      <div className={styles.chartTitle}>品牌协同系数分析</div>
      <V2Table
        rowKey='id'
        defaultColumns={methods.getColumns()}
        onFetch={methods.loadTable}
        filters={tableFilters}
        pagination={false}
        emptyRender
        bordered={false}
        hideColumnPlaceholder
        className={styles.synergyTable}
        rowClassName={methods.getRowClassName}
      />
    </div>
  );
};

export default BrandSynergyAnalysis;
